import React, { useEffect, useState } from "react";
import {
    ErrorMessage,
    Field,
    Form,
    FormikProvider,
    useFormik,
} from "formik";
import * as Yup from "yup";
import { Button, Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CommonFooter, CommonHeaders } from "../../CommonUtils/CommonHeaderFooter";
import { aadhaarValidation, AADHAR_VALIDATION, emailValidation, validateVerhoeff } from "../../CommonUtils/contextVariables";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";

export default function RegistrationForm() {
    const [otpSent, setOtpSent] = useState(false);
    const [timer, setTimer] = useState(300);
    let naviagte = useNavigate();
    // ADD THESE STATES INSIDE RegistrationForm

    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [loginCredentials, setLoginCredentials] = useState({
        studentId: "",
        password: ""
    });
    // Timer Countdown
    useEffect(() => {
        let interval;

        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [otpSent, timer]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;

        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };
    const [taxNo, setTaxNo] = useState('');
    const Formik = useFormik({
        initialValues: {
            aadhaarNo: "",
            mobileNo: "",
            reEnteredMblNo: "",
            email: "",
            otp: "",
            selfCheck: false,
        },

        validationSchema: Yup.object({
            aadhaarNo: Yup.string()
                .required("Aadhar No is Required")
                .matches(AADHAR_VALIDATION, "Invalid Aadhar Number")
                .test("isValid", "Invalid Aadhar Number", function (value) {
                    if (value) {
                        return validateVerhoeff(value);
                    }
                    return true;
                }),

            mobileNo: Yup.string()
                .required("Mobile Number is required")
                .matches(/^[6-9]\d{9}$/, "Enter valid Mobile Number"),

            reEnteredMblNo: Yup.string()
                .required("Re-enter mobile number")
                .oneOf([Yup.ref("mobileNo")], "Mobile numbers must match"),
            // email: Yup.string() .required("Email is required") .email("Invalid email"),
            email: emailValidation,
            otp: otpSent
                ? Yup.string()
                    .required("OTP is required")
                    .matches(/^[0-9]{6}$/, "Enter valid OTP")
                : Yup.string(),

            selfCheck: Yup.boolean().oneOf(
                [true],
                "Please accept declaration"
            ),
        }),

        onSubmit: async (values, { resetForm }) => {
            try {

                if (!otpSent) {
                    const response = await axios.post(
                        config.url.STU_URL + "generateotp",
                        {
                            aadhaarNo: values.aadhaarNo,
                            mobileNo: values.mobileNo,
                            email: values.email,
                        }
                    );

                    if (response.data.status === true) {
                        successAlert2(response?.data?.sdesc);

                        setOtpSent(true);
                        setTimer(300);
                        setTaxNo(response?.data?.txnNo)
                    } else {
                        failureAlert(response?.data?.sdesc);
                    }

                    return;
                }

                // STEP 2 → FINAL SUBMIT
                const finalPayload = {
                    aadhaarNo: values.aadhaarNo,
                    mobileNo: values.mobileNo,
                    email: values.email,
                    otp: values.otp,
                    txnNo: taxNo,
                    selfCheck: values?.selfCheck
                };

                const finalResponse = await axios.post(
                    config.url.STU_URL + "candidate-registration",
                    finalPayload
                );

                if (finalResponse.data.status === true) {

                    const studentId = finalResponse?.data?.candidate_id || "";

                    const password = "Guest@123" //NOSONAR

                    setLoginCredentials({
                        studentId,
                        password
                    });

                    setRegistrationSuccess(true);

                    successAlert2(
                        "You have registered successfully"
                    );

                    resetForm();

                    setOtpSent(false);

                    setTimer(300);
                }

                else {
                    failureAlert(finalResponse?.data?.sdesc);
                }

            } catch (err) {
                console.log(err);
                failureAlert("Something went wrong");
            }
        },
    });

    useEffect(() => {

        if (timer === 0 && otpSent) {

            setOtpSent(false);

            Formik.resetForm();

            Swal.fire({
                icon: "error",
                title: "OTP Expired",
                text: "Your OTP expired. Please register again.",
                confirmButtonColor: "#d33",
                confirmButtonText: "OK"
            }).then(() => {

                naviagte("/");

            });
        }

    }, [timer]);
    // console.log("registrationSuccess", registrationSuccess)
    return (
        <>
            <CommonHeaders />

            {registrationSuccess === true ? (<>
                <Container
                    className="d-flex justify-content-center align-items-center"
                // style={{
                //     minHeight: "100vh",
                //     background: "#f5f7fb",
                //     padding: "20px"
                // }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "700px",
                            background: "#fff",
                            borderRadius: "20px",
                            padding: "60px 40px",
                            textAlign: "center",
                            boxShadow: "0 10px 35px rgba(0,0,0,0.08)"
                        }}
                    >

                        {/* SUCCESS ICON */}
                        <div
                            style={{
                                width: "120px",
                                height: "120px",
                                borderRadius: "50%",
                                background: "#14b8a6",
                                margin: "0 auto 35px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#fff",
                                fontSize: "65px",
                                fontWeight: "bold"
                            }}
                        >
                            ✓
                        </div>

                        {/* TITLE */}
                        <h1
                            style={{
                                fontSize: "46px",
                                fontWeight: "700",
                                color: "#111827",
                                marginBottom: "25px"
                            }}
                        >
                            Thank You for Registration
                        </h1>

                        {/* STUDENT ID BOX */}
                        <div
                            style={{
                                background: "#f8fafc",
                                border: "1px solid #e5e7eb",
                                borderRadius: "16px",
                                padding: "25px",
                                marginBottom: "20px"
                            }}
                        >

                            <h4
                                style={{
                                    color: "#374151",
                                    marginBottom: "15px",
                                    fontWeight: "600"
                                }}
                            >
                                Your Student ID
                            </h4>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "15px",
                                    flexWrap: "wrap"
                                }}
                            >

                                <h2
                                    style={{
                                        color: "#2563eb",
                                        fontWeight: "800",
                                        letterSpacing: "1px",
                                        margin: 0
                                    }}
                                >
                                    {loginCredentials.studentId}
                                </h2>

                                <button
                                    type="button"
                                    onClick={() => {

                                        navigator.clipboard.writeText(
                                            loginCredentials.studentId
                                        );

                                        successAlert2("Student ID Copied");

                                    }}
                                    style={{
                                        border: "none",
                                        background: "#2563eb",
                                        color: "#fff",
                                        padding: "10px 18px",
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        cursor: "pointer"
                                    }}
                                >
                                    Copy
                                </button>

                            </div>

                        </div>

                        {/* PASSWORD MESSAGE */}
                        <div
                            style={{
                                background: "#ecfeff",
                                border: "1px solid #a5f3fc",
                                borderRadius: "16px",
                                padding: "20px",
                                marginBottom: "35px"
                            }}
                        >
                            <p
                                style={{
                                    margin: 0,
                                    color: "#0f172a",
                                    fontSize: "18px",
                                    lineHeight: "1.7"
                                }}
                            >
                                Your password has been sent to your Aadhaar
                                registered mobile number successfully.
                            </p>
                        </div>

                        {/* LOGIN BUTTON */}
                        <button
                            type="button"
                            onClick={() => {

                                naviagte("/", {
                                    state: {
                                        userId: loginCredentials.studentId
                                    }
                                });

                            }}
                            style={{
                                border: "none",
                                background: "#2563eb",
                                color: "#fff",
                                padding: "18px 35px",
                                borderRadius: "14px",
                                fontSize: "18px",
                                fontWeight: "700",
                                cursor: "pointer",
                                minWidth: "280px",
                                boxShadow: "0 10px 25px rgba(37,99,235,0.25)"
                            }}
                        >
                            Click Here To Login
                        </button>

                    </div>
                </Container>



            </>) : (<>




                <div
                    style={{
                        minHeight: "100vh",
                        background: "white",
                        // "linear-gradient(135deg,#0f172a 0%,#111827 45%,#1e293b 100%)",
                        padding: "40px 20px",
                    }}
                >
                    <Container>

                        {/* TOP BAR */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "15px",
                                marginBottom: "30px",
                            }}
                        >
                            <div>
                                <h2
                                    style={{
                                        color: "#082253",
                                        fontWeight: "700",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Student Registration
                                </h2>

                                <p
                                    style={{
                                        color: "#0a182c",
                                        margin: 0,
                                    }}
                                >
                                    Complete your registration for Student Migration Portal
                                </p>
                            </div>

                            <Button
                                onClick={() => naviagte("/")}
                                style={{
                                    background:
                                        "linear-gradient(90deg,#06b6d4,#3b82f6)",
                                    border: "none",
                                    padding: "10px 22px",
                                    borderRadius: "12px",
                                    fontWeight: "600",
                                }}
                            >
                                ← Back to Login
                            </Button>
                        </div>

                        {/* MAIN CARD */}
                        <div
                            style={{
                                background: "rgba(255,255,255,0.08)",
                                border: "1px solid rgba(255,255,255,0.1)",
                                borderRadius: "24px",
                                padding: "35px",
                                backdropFilter: "blur(12px)",
                                boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
                            }}
                        >

                            {/* INFO STRIP */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    marginBottom: "30px",
                                }}
                            >
                                <div
                                    style={{
                                        background: "rgba(34,197,94,0.15)",
                                        border: "1px solid rgba(34,197,94,0.3)",
                                        color: "#021f0c",
                                        padding: "10px 18px",
                                        borderRadius: "12px",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                    }}
                                >
                                    ✓ OTP Verification Required
                                </div>

                                <div
                                    style={{
                                        background: "rgba(239,68,68,0.15)",
                                        border: "1px solid rgba(239,68,68,0.3)",
                                        color: "#410505",
                                        padding: "10px 18px",
                                        borderRadius: "12px",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                    }}
                                >
                                    🔒 Aadhaar Based Registration
                                </div>
                            </div>

                            <FormikProvider value={Formik}>
                                <Form onSubmit={Formik.handleSubmit}>

                                    <Row>

                                        {/* Aadhaar */}
                                        <Col lg={3} md={6} className="mb-4">
                                            <label
                                                style={{
                                                    color: "#04224b",
                                                    fontWeight: "600",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                }}
                                            >
                                                Student Aadhaar Number *
                                            </label>

                                            <Field
                                                type="text"
                                                name="aadhaarNo"
                                                maxLength="12"
                                                disabled={otpSent}
                                                onKeyPress={allowNumbersOnly}
                                                placeholder="Enter Aadhaar Number"
                                                className="form-control" />

                                            <ErrorMessage
                                                name="aadhaarNo"
                                                component="div"
                                                className="text-danger mt-1"
                                            />


                                        </Col>

                                        {/* Mobile */}
                                        <Col lg={3} md={6} className="mb-4">
                                            <label
                                                style={{
                                                    color: "#04224b",
                                                    fontWeight: "600",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                }}
                                            >
                                                Mobile Number *
                                            </label>

                                            <Field
                                                type="text"
                                                name="mobileNo"
                                                maxLength="10"
                                                disabled={otpSent}
                                                placeholder="Enter Mobile Number"
                                                onKeyPress={allowNumbersOnly}
                                                className='form-control'></Field>

                                            <ErrorMessage
                                                name="mobileNo"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </Col>

                                        {/* Re-enter */}
                                        <Col lg={3} md={6} className="mb-4">
                                            <label
                                                style={{
                                                    color: "#04224b",
                                                    fontWeight: "600",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                }}
                                            >
                                                Re-enter Mobile *
                                            </label>

                                            <Field
                                                type="text"
                                                name="reEnteredMblNo"
                                                maxLength="10"
                                                disabled={otpSent}
                                                placeholder="Re-enter Mobile Number"
                                                onKeyPress={allowNumbersOnly}
                                                className='form-control'></Field>

                                            <ErrorMessage
                                                name="reEnteredMblNo"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </Col>

                                        {/* Email */}
                                        <Col lg={3} md={6} className="mb-4">
                                            <label
                                                style={{
                                                    color: "#04224b",
                                                    fontWeight: "600",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                }}
                                            >
                                                Email Address *
                                            </label>

                                            <Field
                                                type="email"
                                                name="email"
                                                disabled={otpSent}
                                                placeholder="Enter Email Address"
                                                className='form-control'></Field>

                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </Col>

                                        {/* OTP */}
                                        {otpSent && (
                                            <Col lg={4} md={6} className="mb-4">

                                                <label
                                                    style={{
                                                        color: "#04224b",
                                                        fontWeight: "600",
                                                        marginBottom: "8px",
                                                        display: "block",
                                                    }}
                                                >
                                                    OTP Verification *
                                                </label>

                                                <Field
                                                    type="text"
                                                    name="otp"
                                                    maxLength="6"
                                                    placeholder="Enter 6 Digit OTP"
                                                    className='form-control'

                                                />

                                                <ErrorMessage
                                                    name="otp"
                                                    component="div"
                                                    className="text-danger mt-1"
                                                />

                                                <div
                                                    style={{
                                                        marginTop: "12px",
                                                        background:
                                                            timer <= 30
                                                                ? "rgba(239,68,68,0.15)"
                                                                : "rgba(34,197,94,0.15)",
                                                        border:
                                                            timer <= 30
                                                                ? "1px solid rgba(239,68,68,0.3)"
                                                                : "1px solid rgba(34,197,94,0.3)",
                                                        color:
                                                            timer <= 30
                                                                ? "#572020"
                                                                : "#062210",
                                                        padding: "10px 15px",
                                                        borderRadius: "12px",
                                                        fontWeight: "600",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    ⏱ OTP Expires In : {formatTime(timer)}
                                                </div>
                                            </Col>
                                        )}
                                    </Row>

                                    {/* DECLARATION */}
                                    <div
                                        style={{
                                            background: "rgba(245,158,11,0.12)",
                                            border: "1px solid rgba(245,158,11,0.25)",
                                            borderRadius: "16px",
                                            padding: "18px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "10px",
                                            }}
                                        >
                                            <Field
                                                type="checkbox"
                                                name="selfCheck"
                                                style={{
                                                    marginTop: "5px",
                                                }}
                                            />

                                            <div>
                                                <span
                                                    style={{
                                                        color: "#725c04",
                                                        fontSize: "15px",
                                                    }}
                                                >
                                                    I hereby declare that all the
                                                    information furnished above is true and
                                                    correct to the best of my knowledge.
                                                </span>

                                                <ErrorMessage
                                                    name="selfCheck"
                                                    component="div"
                                                    className="text-danger mt-1"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* BUTTON */}
                                    <div
                                        style={{
                                            marginTop: "35px",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {!otpSent ? (
                                            <button
                                                type="submit"
                                                style={{
                                                    background:
                                                        "linear-gradient(90deg,#2563eb,#06b6d4)",
                                                    border: "none",
                                                    color: "#fff",
                                                    padding: "15px 40px",
                                                    borderRadius: "14px",
                                                    fontWeight: "700",
                                                    fontSize: "16px",
                                                    minWidth: "240px",
                                                    boxShadow:
                                                        "0 10px 25px rgba(37,99,235,0.35)",
                                                }}
                                            >
                                                Generate OTP
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                disabled={timer === 0}
                                                style={{
                                                    background:
                                                        "linear-gradient(90deg,#16a34a,#22c55e)",
                                                    border: "none",
                                                    color: "#fff",
                                                    padding: "15px 40px",
                                                    borderRadius: "14px",
                                                    fontWeight: "700",
                                                    fontSize: "16px",
                                                    minWidth: "260px",
                                                    boxShadow:
                                                        "0 10px 25px rgba(34,197,94,0.35)",
                                                }}
                                            >
                                                Submit Registration
                                            </button>
                                        )}
                                    </div>

                                </Form>
                            </FormikProvider>
                        </div>
                    </Container>
                </div>
            </>)}

            <CommonFooter />
        </>
    );
}